/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  UPDATE_BLOG_DIR(state, payload){
    var index = state.blogDir.findIndex(function(item){return item.id == payload.id})
    Object.assign(state.blogDir[index], payload)
  },
  UPDATE_BLOG_DIR_NAME(state, payload){
    var index = state.blogDir.findIndex(function(item){return item.id == payload.id})
    state.blogDir[index].name =  payload.name
  },
  CREATE_BLOG_DIR(state, payload){
    state.blogDir.push(payload)
  },
  DELETE_BLOG_DIR(state, payload){
    state.blogDir.unshift(payload)
  },
  SET_BLOG_DIR(state, payload){
    state.blogDir = payload.sort(function(a,b) {return a.parent < b.parent ? -1 : a.parent < b.parent ? 1 : 0 })
  },
  SET_ACTIVE_BLOG(state, payload){
    state.activeBlog = payload
  },
  SET_USER_BLOG(state, payload){
    state.userBlogs = payload
  }
}
